import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { environment } from '../../../environments/environment';
import { Toro } from '../../api/common/enumerations';
import { ApiUrlService } from '../../api/services/api-url.service';
import { BroadcastService } from '../../services/broadcast.service';
import { OverlayManagerService } from '../../services/overlay-manager.service';
import { MobileDeviceService } from '../services/mobile-device.service';
import { LocationManagerService } from './../../api/managers/location-manager.service';
import { ConfigsLoaderService } from './../../services/configs-loader.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.less']
})
export class FooterComponent implements OnInit, OnDestroy {
    @Input() isUnAuthenticatedRoute = false;

    DocumentType = Toro.DocumentType;

    version = '';
    apiVersion: any;
    apiEndpointUrl = '';
    showApiEndpoint = false;
    blurBackground = false;
    currentYear = (new Date()).getFullYear();

    // =========================================================================================================================================================
    // C'tor, Init and Destroy
    // =========================================================================================================================================================

    constructor(protected apiUrlService: ApiUrlService,
        private broadcastService: BroadcastService,
        private mobileDeviceService: MobileDeviceService,
        private locationManager: LocationManagerService,
        private overlayManager: OverlayManagerService,
        private configService: ConfigsLoaderService) { }

    ngOnInit() {

        this.version = this.configService.AppVersion;

        this.apiEndpointUrl = this.apiUrlService.getApiEndpointUrl(environment.defaultApiEndpoint);
        this.showApiEndpoint = environment['showEndpointInFooter'];

        this.overlayManager.toggleBlurBackground
            .pipe(untilDestroyed(this))
            .subscribe((blurBackground: boolean) => {
                this.blurBackground = blurBackground;
            });

        this.locationManager.getServerAPIVersion().subscribe(res => {
            this.apiVersion = res;
        })
    }

    ngOnDestroy(): void {
        /** Implemented to support untilDestroyed() */
    }

    // =========================================================================================================================================================
    // Event Handlers
    // =========================================================================================================================================================

    onShowDocument(documentType: Toro.DocumentType) {
        this.broadcastService.showPopupDialog.next({ documentType: documentType });
    }

    getImageMapCoordinates(logo: string): string {
        switch (logo) {
            case 'toro':
                if (this.mobileDeviceService.isSmallWdith) return '0,0,45,35';
                if (this.mobileDeviceService.isMediumWidth) return '0,0,65,50';
                return '0,0,90, 68';

            case 'irritrol':
                if (this.mobileDeviceService.isSmallWdith) return '60,0,125,35';
                if (this.mobileDeviceService.isMediumWidth) return '85,0,180,50';
                return '115,0,245,68';

            case 'uniquelighting':
                if (this.mobileDeviceService.isSmallWdith) return '140,0,200,35';
                if (this.mobileDeviceService.isMediumWidth) return '197,0,285,50';
                return '270,0,385,68';
        }
    }

}
